export const fetchData = async() => {
    console.log("inside function")

    const header = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer key3N7kAsVwzQr6RW',
        }

    }

    const response = await fetch('https://api.airtable.com/v0/app6PVHwPZLoBih3Q/Appointments', header)
        .then(response => response.json())
        .then(data => data)
        .catch(err => console.log("error", err))

    return response

}